// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/PriceBroadcast/PriceBroadcast.css
// module id = 1626
// module chunks = 0